import Validation, {
    requiredValidation,
    emailValidation,
    passwordValidation,
    azTextWithSpacesValidation
} from 'vendor/zod/validationZod';
import { handleUrlSearchParams } from 'helpers/urlsearchparams/urlSearchParams';
import AjaxPost from 'components/ajaxpost/ajaxpost';
import { trackEvent } from 'vendor/google/gtm/gtmEventTracker';
import getTranslation from 'helpers/translation/getTranslation';
import { object, custom } from 'zod';

export const registerForm = (function () {
    /*-----------------------------INIT | initialize form validation------------------------------*/
    const init = () => {
        const baseSchema = object({
            email: requiredValidation.pipe(emailValidation),
            password: requiredValidation.pipe(passwordValidation),
            confirmPassword: custom(
                (val) => {
                    const passwordVal = document.querySelector('input[name="password"]')?.value;
                    if (val === undefined || passwordVal === undefined) {
                        return true;
                    }

                    return val === passwordVal;
                },
                getTranslation('validation', 'INVALID_PASSWORD_EQUALITY')
            )
        });

        const consumerSchema = baseSchema.extend({
            firstName: requiredValidation.pipe(azTextWithSpacesValidation),
            lastName: requiredValidation.pipe(azTextWithSpacesValidation)
        });

        // Load validation
        const registerValidation = new Validation({
            form: '.register-form',
            schema: document.getElementById('email').readOnly === true ? baseSchema : consumerSchema,
            onValidationSubmit: (validationObject) => {
                _handleFormSubmit(validationObject);
            }
        });

        registerValidation.initValidation();
    };

    /*-----------------------------FORM SUBMIT | submit the form------------------------------*/
    const _handleFormSubmit = (validationObject) => {
        const formElement = validationObject.config.formElement;

        const params = new handleUrlSearchParams({
            form: formElement,
            fieldSelector: '.form-control',
            addEmptyFields: false
        });
        const postData = params.renderSearchParams();

        const postForm = new AjaxPost({
            formElement,
            validationObject,
            postData,
            hideFormOnSuccess: true,
            messageContainer: document.getElementById('register-message-container'),
            onFormSuccess: () => {
                trackEvent('Account', 'Account page', 'Create account successful');
            }
        });

        postForm.postFormData();
    };

    return {
        init: init
    };
})();
